import { PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";

const AddonsHeader = ({ onCreateRegular, total = 0 }) => {
    const { t } = useTranslation(["addons"]);

    return (
        <div className="my-3 flex min-w-0 flex-col gap-3 sm:my-5 sm:flex-row sm:flex-wrap sm:items-center sm:justify-between sm:gap-4">
            <div className="min-w-0 text-lg font-bold sm:text-[1.2rem]">
                {t("title")} <span className="text-[#5d5dff]">({total})</span>
            </div>
            <Button type="primary" icon={<PlusOutlined />} onClick={onCreateRegular}>
                {t("createNewAddon")}
            </Button>
        </div>
    );
};

AddonsHeader.propTypes = {
    onCreateRegular: PropTypes.func.isRequired,
    total: PropTypes.number,
};

export default AddonsHeader;
